import { render } from "./DialogNewDatabankCreateWait.vue?vue&type=template&id=4b59d7fe"
import script from "./DialogNewDatabankCreateWait.vue?vue&type=script&lang=js"
export * from "./DialogNewDatabankCreateWait.vue?vue&type=script&lang=js"

import "./DialogNewDatabankCreateWait.vue?vue&type=style&index=0&id=4b59d7fe&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__